<template>
   <v-container class="plicante-page mt-15 ml-2" style="max-width: 1900px;" v-if="!error">
    <v-row>
      <v-col cols="12">
        <h5 class="text-h5 font-weight-bold header mb-3 override-expense" v-html="title"></h5>
      </v-col>
    </v-row>

    <div class="page-actions d-flex justify-space-between mr-5">
      <!-- <div width="250px">
        <v-text-field 
          width="200px"
          variant="outlined"
          density="compact"
          placeholder="Поиск"
          v-model="search"
          class="mr-5"
        />
      </div> -->

      <div>
        <v-btn
          class="report-action-button mr-5 mb-3"
          v-for="button in buttons" 
          :key="button.path" 
          @click="addNewReport(button.path)" 
          :loading="loadingMap[button.path]"
          :disabled="loadingMap[button.path] || (button.disabledUrl && !canApplyMap[button.path])"
          >
          {{ button.name }}</v-btn>
      </div>
    </div>
    <div class="filters-row d-flex justify-space-between mr-5">
      <div class="filters-content d-flex justify-space-between mr-5">
        <div v-if="filtersEl && filtersEl.length">
          <div v-for="form in filtersEl" :key="form.id">
            <div v-if="form.filters && form.filters.length" class="filter-list d-flex">
              <div
                v-for="filterCode in form.filters"
                :key="filterCode" 
                class="filter-item mr-5"
              >
                <p>{{ allHeaders.find(h => h.code === filterCode)?.name}}</p>

                <v-autocomplete
                  v-model="selectedFilters[filterCode]"
                  variant="outlined"
                  density="compact"
                  width="300px"
                  :items="distionaryItems[filterCode]"
                  item-title="shortForm"
                  item-value="id"
                  multiple
                  @update:modelValue="onSelectChange($event)"
                  :placeholder="headers.find(h => h.code === filterCode)?.text || 'Выберите значение'"
                >
                  <template v-slot:append-item>
                    <div class="filter-pagination ml-5 d-flex align-center">
                      <v-btn
                        size="small"
                        :color="distionaryItemsOffSet[filterCode] === 0 ? 'primary' : ''"
                        @click="updatePage(0, filterCode)"
                        v-if="distionaryItemsOffSet[filterCode] !== 0"
                      >1</v-btn>

                      <span v-if="distionaryItemsOffSet[filterCode] > 2" class="px-2">…</span>

                      <v-btn
                        v-if="distionaryItemsOffSet[filterCode] > 1"
                        size="small"
                        @click="updatePage(distionaryItemsOffSet[filterCode] - 1, filterCode)"
                      >
                        {{ distionaryItemsOffSet[filterCode] }}
                      </v-btn>

                      <template
                        v-for="i in Math.min(3, distionaryItemsLength[filterCode] - distionaryItemsOffSet[filterCode])"
                        :key="'mid-' + i"
                      >
                        <v-btn
                          size="small"
                          :color="i === 1 ? 'primary' : ''"
                          @click="updatePage(distionaryItemsOffSet[filterCode] + i - 1, filterCode)"
                        >
                          {{ distionaryItemsOffSet[filterCode] + i }}
                        </v-btn>
                      </template>

                      <span
                        v-if="distionaryItemsOffSet[filterCode] < distionaryItemsLength[filterCode] - 4"
                        class="px-2"
                      >…</span>

                      <v-btn
                        size="small"
                        :color="distionaryItemsOffSet[filterCode] === distionaryItemsLength[filterCode] - 1 ? 'primary' : ''"
                        @click="updatePage(distionaryItemsLength[filterCode] - 1, filterCode)"
                        v-if="distionaryItemsOffSet[filterCode] < distionaryItemsLength[filterCode] - 3"
                      >
                        {{ distionaryItemsLength[filterCode] }}
                      </v-btn>
                    </div>
                  </template>
                </v-autocomplete>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      <div class="table-section mr-5">
        <v-data-table-server
          class="custom-bordered-table"
          :headers="headers"
          :items="items"
          v-model:page="page"
          v-model:items-per-page="pageSize"
          :items-length="itemsLength"
          :items-per-page-options="[1, 10, 25, 50, 100]"
          @update:page="getFullData"
          @update:items-per-page="onChangePageSize"
        >
        <template #item="{ item }">
          <tr @click="onRowPlicanteClick(item)" style="cursor: pointer; max-height: 35px;" v-if="headers">
            <td v-for="header in headers" :key="header.value" class="no-border date_item"               
            @mouseenter="showHover($event, item[header.value])"
            @mouseleave="hideHover">
                <p style="height: 59px!important; overflow: hidden; padding: 12px;" v-if="typeof item[header.value] === 'string'">
                  {{ item[header.value] }}
                </p> 
                 <p style="height: 59px!important; overflow: hidden; padding: 12px;" v-else-if="Array.isArray(item[header.value])">
                   {{ item[header.value].map(el => el.attributes || el).join('; ') }}
                </p> 
                <p style="height: 59px!important; overflow: hidden; padding: 12px;" v-else>
                  {{ item[header.value] }}
                </p> 
            </td>
          </tr>
        </template>

        </v-data-table-server>
        <div
          v-if="hoverText && typeof hoverText === 'string'"
          :style="{ top: `${hoverPos.top}px`, left: `${hoverPos.left}px` }"
          class="hover-popup-fixed"
        >
          {{ hoverText }}
        </div>
        <div 
          v-else-if="hoverText && Array.isArray(hoverText)"
          :style="{ top: `${hoverPos.top}px`, left: `${hoverPos.left}px` }"
          class="hover-popup-fixed"
          >
            {{ hoverText.map(el => el.attributes || el).join('; ') }}
        </div>
      </div>
    </v-container>
    <v-container v-else class="mt-15">
      <v-alert text="Такой таблицы не существует"></v-alert>
    </v-container>
</template>

<script>
import requestService from '@/services/request.service';
import DateRangeFilter from '../DateRangeFilter.vue';
import plicanteRequestService from '@/services/plicante.request.service';
import { mapGetters } from 'vuex'

export default {
  components: {
    DateRangeFilter
  },
  data() {
    return {
      title: "Оперативные отчеты",
      statuses: [],
      signStateItems: [],
      hoverText: '',
      hoverPos: { top: 0, left: 0 },
      search: '',
      items: [],
      jsonFileReport: null,
      pdfFileReport: null,
      error: false,
      headers: [],
      filters: {
        reportDate: [],
        period: [],
        agreementDate: [],
        SubsidyTitle: [],
        status: [],
        statusDate: [],
        signState: []
      },
      itemsTitle: [],
      page: 1,
      pageSize: 10,
      visibleHeaders: null,
      distionaryItems: {},
      distionaryItemsLength: {},
      distionaryItemsOffSet: {},
      reportType: null,
      allHeaders: [],
      filtersEl: [],
      selectedFilters: {},
      tableObjectAttributes: null,
      withInn: false,
      innCode: null,
      buttons: [],
      rowPath: '',
      attrCode: null,
      itemsLength: 0,
      canApplyMap: {},
      loadingMap: {},
      fullDataRequest: null,
      fullDataRequestKey: null,
      fullDataLoadedKey: null
    };
  },
  computed: {
    ...mapGetters(['getUserData', 'getInn']),
    userHasInn() {
      return Boolean(this.getInn);
    },
    filteredItems() {
        if (!this.search) return this.items;
        const s = this.search.toLowerCase().trim();

        function isoLooksLikeDate(str) {
          return typeof str === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(str);
        }

        function isoToYMD(iso) {
          return iso.slice(0, 10);
        }

        function isoToDMY(iso) {
          const ymd = isoToYMD(iso);
          const [y, m, d] = ymd.split('-');
          return `${d}.${m}.${y}`; // 25.07.2025
          }

        function valueToSearchableString(val) {
            if (val == null) return '';
            if (Array.isArray(val)) {
              return val.map(valueToSearchableString).join(' ');
            }
            if (typeof val === 'object') {
              // берем значения объекта (например app.title)
              return Object.values(val).map(valueToSearchableString).join(' ');
            }
            const str = String(val);
            if (isoLooksLikeDate(str)) {
              // возвращаем оба формата — yyyy-mm-dd и dd.mm.yyyy
              return `${isoToYMD(str)} ${isoToDMY(str)}`.toLowerCase();
            }
            return str.toLowerCase();
          }

          return this.items.filter(item =>
            Object.values(item).some(v => valueToSearchableString(v).includes(s))
          );
    }
  },
  methods: {
    loadCanApply(button) {
      if (!button.disabledUrl) {
        return;
      }

      this.loadingMap[button.path] = true;

      plicanteRequestService.get(button.disabledUrl)
        .then(data => {
          this.canApplyMap[button.path] = data.data.canApply;
        })
        .catch(err => {
          console.log(err);
          this.canApplyMap[button.path] = false;
        })
        .finally(() => {
          this.loadingMap[button.path] = false;
        });
    },
    onSelectChange(event) {
      const filters = []
      for (const [key, value] of Object.entries(this.selectedFilters)) {
        if (!value?.length || value?.length == 0) {
          continue
        } 
        let nestedTemplateId = 0;
        let itemFilter = {}
        const linkedInstanceId = event?.filter(v => v != null);
        this.tableObjectAttributes[0].attributeValueTypes.forEach(item => {
          if (item.code == key) {
            itemFilter = {
              "id": item.id,
              "code": item.code,
              "dataType": item.value.dataType,
              "attributeType": "RELATION_DICTIONARY",
              "name": "Вид отчета",
              "search": true,
              "multiple": false,
              "filterCode": null,
              "defaultValues": null,
              "dictionaryType": {
              "dictionaryId": item.value.dataList[0].linkedTemplateId,
              "dictType": "DICTIONARY",
              "managedGroupId": 0,
              "managingDictionaryId": 0
            },
              "availableStatuses": null
            }
          nestedTemplateId = item.value.dataList[0].linkedTemplateId
        }
      })
      const filter = {
        "attribute": itemFilter,
        "complexCondition": null,
        "nestedTemplateId": nestedTemplateId,
        "nestedFilter": null,
        "condition": {
          "clause": "EQUALS",
          "valueData": {
            "type": "LinkData",
            "id": 0,
            "data": null,
            "action": null,
            "linkedInstanceId": linkedInstanceId,
            "linkedTemplateId": 0,
            "linkedTemplateType": null,
            "managedDictionaryGroupId": 0,
            "managedDictionaryTemplateId": 0,
            "attributes": null
          }
        },
      }
      filters.push(filter)
      }
      this.getFullData(this.page - 1, filters)
    },
    updatePage(i, code) {
     this.updateDictionary(i, code)
    },
    updateDictionary(i, code) {
      this.tableObjectAttributes[0].attributeValueTypes.forEach(item => {
        if (item.code == code) {
          this.getItemsForDictionary(item, item.code, i)
        }
     })
    },
    getItemsForDictionary(el, code, offSet = 0) {
      let id = el.value.dataList[0].linkedTemplateId;
      if (el.attributeType == "RELATION_REVERSE") {
        id = el.valueTypeInstance.dataListTemplate[0].data.ownerId
      }
      const payload = {
        "tablePageType": {
          "menuItemType": {
            "id": id              
            },
            "offSet": offSet,
            "pageSize": 10,
            "getLinkedWithOwner": "true"
        },
        "filterType": {
          "owner": {
              "templateId": id,
          }
        }
      }
      const url = `${process.env.VUE_APP_BASE_URL}/register-rest/operator/countedTableAttributes/search`
      plicanteRequestService.post(url, payload)
      .then(data => {
        data.data.tableObjectAttributes = data.data.tableObjectAttributes.filter(el => el.shortForm.length > 0)
        this.distionaryItems[code.trim()] =[...data.data.tableObjectAttributes]
        this.distionaryItemsLength[code.trim()] = Math.ceil(data.data.count / 10);
        this.distionaryItemsOffSet[code.trim()] = offSet;
      })
      .catch(err => {
        console.log(err)
      })
    },
    addNewReport(report) {
      this.$router.push(`/form?id=${report}`)
    },
    formatCell(item, field) {
      const val = item[field]
      if (!val && val !== 0) return ''

      // Проверка ISO-формата даты
      const isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z?$/
      if (typeof val === 'string' && isoDateRegex.test(val)) {
        return val.slice(0, 10)
      }

      return val
    },
    onRowPlicanteClick(item) {
      if (this.buttons.length == 1) {
        this.$router.push(
          `/form?id=${this.buttons[0].path}&instanceId=${item.id}&version=${item.version}&attributeId=${item.attributesId}${item.dataId ? `&dataId=${item.dataId}` : ''}`
        )
      } else {
        if (item.attrCode) {
          let path = this.buttons.find(el => el.id == item.attrCode).path
          this.$router.push(
          `/form?id=${path}&instanceId=${item.id}&version=${item.version}&attributeId=${item.attributesId}${item.dataId ? `&dataId=${item.dataId}` : ''}`
        )
        } else {
          console.log('Не указан код атрибута и его значение')
        }
      }
    },
    onFilterChange() {
      this.page = 1;
      this.getFullData();
    },
    addedFormPage() {
      this.$router.push(this.buttonUrl)
    },
    onChangePageSize() {
      this.page = 1
      this.getFullData()
    },
    showHover(event, text) {
      const rect = event.target.getBoundingClientRect();
      this.hoverPos = {
        top: rect.top - 5, 
        left: rect.left
      };
      this.hoverText = text;
    },
    hideHover() {
      this.hoverText = '';
    },
    getAllLists() {
      const url = `${process.env.VUE_APP_BASE_URL}/v3/dictionaries/${this.id}`
      requestService.get(url)
      .then(data => {
        this.signStateItems = data.data.signStates;
        this.statuses = data.data.statuses;
      })
      .catch(() => {
        console.log("Ошибка при получении данных справочников")
      })
    },
    getItemsTitles() {
      const url = `${process.env.VUE_APP_BASE_URL}/v3/ExpenseReports`;
      requestService.get(url)
        .then((data) => {
          const itemsTitle = new Set([])

          data.data.results.forEach(el => {
            itemsTitle.add(el.subsidyTitle)
          })

          this.itemsTitle = Array.from(itemsTitle)
        })
    },
    flattenAttributes(item) {
      const flat = { 
        id: item.id,
        version: item.version,
        dataId: item.attributeValueTypes.find(el => el.code == this.jsonFileReport)?.value.dataList[0]?.id || '',
        attributesId: item.attributeValueTypes.find(el => el.code == this.jsonFileReport)?.id || ''
      }
      if (Array.isArray(item.attributeValueTypes)) {
        item.attributeValueTypes.forEach(attr => {
          const code = attr.code
          let val = null

          if (attr.value && Array.isArray(attr.value.dataList) && attr.value.dataList.length > 0) {
            const data = attr.value.dataList[0].data
            switch (attr.value.dataType) {
              case 'STRING':
                val = data
                break
              case 'DATE':
                val = new Date(data).toLocaleDateString()
                break
              case 'BLOB':
                val = data?.name || null
                break
              case 'LINK':
                if (attr.code == this.attrCode) {
                  flat['attrCode'] = attr.value.dataList[0].data.memberId;
                }
                val = attr.value.dataList
                break
              default:
                val = data
            }
          }

          flat[code] = val
        })
      }
      return flat
    },
    getParams() {
      const url = `${process.env.VUE_APP_BASE_URL}/forms-storage/forms-index.json`;
      requestService.get(url)
      .then(data => {
        data.data.forEach(el => {
          if (el.tableId == this.$route.params.id) {
            this.title = el.title;
            if (el.attrCode) {
              this.attrCode = el.attrCode
            }
          }
          if (el.withInn && el.tableId == this.$route.params.id ) {
            this.withInn = true
          }
          if (el.tableId && el.tableId == this.$route.params.id) {
            if (el.jsonFileReport) {
              this.jsonFileReport = el.jsonFileReport;
            }
            if (el.pdfFileReport) {
              this.pdfFileReport = el.pdfFileReport;
            }
            // if (!el.jsonFileReport){
            //   console.log("Не указана связь между атрибутом plicante и формой")
            // }
            this.allHeaders = this.headers;
            if (el.visibleHeaders) {
              this.headers = this.headers.filter(header => el.visibleHeaders.includes(header.code))
            }
            if (el.filters) {
              this.filtersEl.push(el)
            }
            if (el.withInn) {
              this.innCode = el.withInn;
            }
            if (el.buttons) {
              this.buttons = el.buttons
              this.buttons.forEach(button => this.loadCanApply(button));
            }
          }
        })
        if (this.filtersEl && this.filtersEl.length) {
          this.filtersEl.forEach(form => {
            if (form.filters && form.filters.length) {
              form.filters.forEach(filterCode => {
                if (!(filterCode in this.selectedFilters)) {
                  this.selectedFilters = { ...this.selectedFilters, [filterCode]: null }
                }
              })
            }
          })
        }
        this.getFullData()
      })
      .catch(err => {
        console.log(err)
      })
    },
    getFullData(page, filter = []) {
      const url = `${process.env.VUE_APP_BASE_URL}/register-rest/operator/countedTableAttributes/search`;
        const baseInnFilter = this.userHasInn && this.withInn
    ? {
        attribute: {
          // id: 3780,
          // code: "object_template_5575_org",
          id: this.allHeaders.find(el => el.code == this.innCode)?.attributeId,
          code: this.innCode,
          dataType: "LINK",
          attributeType: this.allHeaders.find(el => el.code == this.innCode)?.attributeType,
          name: this.allHeaders.find(el => el.code == this.innCode)?.name,
          search: true,
          multiple: false,
          filterCode: null,
          defaultValues: null,
          dictionaryType: null,
          availableStatuses: null
        },
        condition: {
          clause: "LIKE",
          valueData: {
            type: "LinkData",
            id: 0,
            data: null,
            action: null,
            linkedInstanceId: null,
            linkedTemplateId: 0,
            linkedTemplateType: null,
            managedDictionaryGroupId: 0,
            managedDictionaryTemplateId: 0,
            attributes: null
          }
        },
        complexCondition: null,
        nestedTemplateId: 3318,
        nestedFilter: {
          excludeIds: null,
          inboundCondition: null,
          filter: [
            {
              attribute: {
                id: 545,
                code: "inn",
                dataType: "STRING",
                attributeType: "STRING",
                name: "ИНН",
                search: true,
                multiple: false,
                filterCode: null,
                defaultValues: [],
                dictionaryType: null,
                availableStatuses: null
              },
              condition: {
                clause: "LIKE",
                valueData: {
                  type: "StringData",
                  id: 0,
                  data: this.getInn,
                  action: null
                }
              },
              complexCondition: null,
              nestedTemplateId: 0,
              nestedFilter: null
            }
          ],
          includeIds: null,
          owner: null,
          shortFormCondition: null
        }
      }
    : null

    const baseUserFilter = !this.userHasInn
      ? {
        "attribute": {
          "id": this.allHeaders.find(el => el.code == "creator")?.attributeId,
          "code": "creator",
          "dataType": "STRING",
          "attributeType": "DUPLICATE_ATTRIBUTE_CREATOR",
          "name": "Создатель",
          "search": true,
          "multiple": false,
          "filterCode": null,
          "defaultValues": [],
          "dictionaryType": null,
          "availableStatuses": null
        },
        "condition": {
          "clause": "LIKE",
          "valueData": {
            "type": "StringData",
            "id": 0,
            "data": this.getUserData?.userName,
            "action": null
          }
        },
        "complexCondition": null,
        "nestedTemplateId": 0,
        "nestedFilter": null
      }
      : null

      const payload = {
        tablePageType: {
          menuItemType: {
            id: this.$route.params.id,
            menuType: "TEMPLATE"
          },
          offSet: this.page - 1,
          pageSize: this.pageSize,
          sorts: [
            {
              code: "id",
              sortDirection: "DESC"
            }
          ],
          attributesIds: []
        },
        filterType: {
          inboundSearch: false,
          filter: [baseInnFilter, baseUserFilter, ...filter].filter(Boolean)
        }
      }

      const requestKey = JSON.stringify(payload)

      if (this.fullDataRequest && this.fullDataRequestKey === requestKey) {
        return this.fullDataRequest
      }

      if (this.fullDataLoadedKey === requestKey) {
        return Promise.resolve()
      }

      const pagee = this.page
      const request = plicanteRequestService.post(url, payload)
      .then(data => {
        if (this.fullDataRequestKey !== requestKey) {
          return data
        }

        this.page = pagee
        this.items = data.data.tableObjectAttributes.map(obj => this.flattenAttributes(obj));
        this.tableObjectAttributes = data.data.tableObjectAttributes;
        this.itemsLength = data.data.count;
        this.filtersEl.forEach(el => {
          el.filters.forEach(filter => {
            if (data.data.tableObjectAttributes[0].attributeValueTypes) {
              data.data.tableObjectAttributes[0].attributeValueTypes.forEach(item => {
                if (item.code == filter) {
                  this.getItemsForDictionary(item, item.code, 0)
                }
              })
            }
          })
        })
        this.fullDataLoadedKey = requestKey
        return data
      })
      .catch(err => {
        console.log(err)
        return null
      })
      .finally(() => {
        if (this.fullDataRequest === request) {
          this.fullDataRequest = null
          this.fullDataRequestKey = null
        }
      })

      this.fullDataRequest = request
      this.fullDataRequestKey = requestKey

      return request
    },
    getHeaders() {
      const url = `${process.env.VUE_APP_BASE_URL}/register-rest/operator/tableViewTemplate/search`
      const payload = {
        "menuItemType": {
           "id": +(this.$route.params.id),
            "menuType": "TEMPLATE"
          }
      }
      plicanteRequestService.post(url, payload)
      .then(data => {
        this.headers = this.formattedHeaders(data.data.metaAttributes);
        this.getParams()
      })
      .catch(err => {
        console.log(err)
      })
    },
    formattedHeaders(headers) {
      return headers.map(item => ({
      ...item, 
      title: item.name, 
      value: item.code
      }));
    },
    flattenItem(item) {
      const flat = {}
      if (item.attributeValueTypes && Array.isArray(item.attributeValueTypes)) {
        item.attributeValueTypes.forEach(attr => {
          flat[attr.code] = attr.value?.dataList?.[0]?.data ?? null
        })
      }
      return flat
    }
  },
  mounted() {
    this.getHeaders();
    // this.getFullData();
  }
};
</script>

<style lang="css" scoped>

  .text-h5 {
    color: var(--app-text)
  }

  .custom-bordered-table >>> table {
    border: 1px solid var(--app-border);
    border-collapse: collapse;
  }

  .custom-bordered-table >>> th,
  .custom-bordered-table >>> td {
    border: 1px solid var(--app-border);
    padding: 8px;
    height: 30px;
  }

  .custom-bordered-table >>> td {
    height: 30px!important;
  }

  .custom-bordered-table >>> th {
    background-color: var(--app-surface-muted);
    color: var(--app-text);
  }

  .custom-bordered-table >>> th span {
      font-weight: 600;
      font-size: 12px;
  }

  .custom-bordered-table >>> tbody tr:hover {
    background-color: var(--app-primary-soft);
    cursor: pointer;
  }

  td .no-border {
    border: none;
  }

  .innerItem {
    font-weight: 600; 
    font-size: 11px; 
    padding: 3px; 
    border-radius: 5px; 
    color: var(--app-on-accent)!important
  }

  .date_item {
    width: 200px;
  }

  .prepend__sort {
    background-color: var(--app-warning-soft);
    height: 50px;
  }

  .text-wrapper {
    position: relative;
    height: 55px !important;
    overflow: hidden;
    display: block;
  }

  .hover-popup-fixed {
    position: fixed;
    background: var(--app-surface-elevated);
    color: var(--app-text);
    border: 1px solid var(--app-border);
    padding: 10px 15px;
    z-index: 9999;
    max-width: 300px;
    box-shadow: 0 2px 8px var(--app-shadow);
    white-space: normal;
    pointer-events: none;
    font-size: 13px;
    border-radius: 10px;
  }

  @media (max-width: 480px) {
    .plicante-page {
      margin-left: 0 !important;
      padding: 10px !important;
    }

    .plicante-page .text-h5 {
      font-size: clamp(18px, 6vw, 22px) !important;
      line-height: 1.3;
      overflow-wrap: anywhere;
    }

    .page-actions,
    .filters-row,
    .filters-content,
    .filter-list {
      width: 100%;
      min-width: 0;
      flex-direction: column;
      margin-right: 0 !important;
    }

    .page-actions > div,
    .filter-item,
    .table-section {
      width: 100%;
      min-width: 0;
      margin-right: 0 !important;
    }

    .page-actions > div {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .report-action-button {
      width: 100%;
      max-width: 100%;
      min-width: 0 !important;
      min-height: 44px;
      height: auto !important;
      padding: 10px 12px;
      margin-right: 0 !important;
      margin-bottom: 0 !important;
    }

    .report-action-button :deep(.v-btn__content) {
      width: 100%;
      min-width: 0;
      white-space: normal !important;
      overflow-wrap: anywhere;
      word-break: break-word;
      line-height: 1.35;
      text-align: center;
    }

    .filter-item :deep(.v-input) {
      width: 100% !important;
      max-width: 100%;
      min-width: 0;
    }

    .filter-pagination {
      flex-wrap: wrap;
      gap: 4px;
      margin: 0 8px !important;
    }

    .filter-pagination :deep(.v-btn) {
      min-width: 32px;
      padding-inline: 6px;
    }

    .table-section :deep(.v-table__wrapper) {
      overflow-x: auto;
      overscroll-behavior-inline: contain;
      -webkit-overflow-scrolling: touch;
    }

    .hover-popup-fixed {
      display: none;
    }
  }
</style>
